var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralProgram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 14.346,
    viewBox: "0 0 14.857 14.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1752",
    "data-name": "Rectangle 1752",
    width: 14.857,
    height: 14.346,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3140",
    "data-name": "Group 3140",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3139",
    "data-name": "Group 3139",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    d: "M6.714.2a1.282,1.282,0,0,1,1.222.889L8.882,4h3.06A1.285,1.285,0,0,1,12.7,6.324l-2.474,1.8.946,2.91a1.268,1.268,0,0,1-.179,1.15,1.3,1.3,0,0,1-1.045.535,1.275,1.275,0,0,1-.754-.248l-2.475-1.8-2.475,1.8a1.277,1.277,0,0,1-.754.248,1.3,1.3,0,0,1-1.045-.535,1.268,1.268,0,0,1-.179-1.149l.946-2.91L.73,6.323A1.285,1.285,0,0,1,1.486,4h3.06l.946-2.91A1.282,1.282,0,0,1,6.714.2Zm4.259,5.4H8.654A1.282,1.282,0,0,1,7.431,4.71L6.714,2.5,6,4.71A1.282,1.282,0,0,1,4.775,5.6H2.454L4.332,6.962A1.282,1.282,0,0,1,4.8,8.4l-.717,2.207L5.958,9.241a1.286,1.286,0,0,1,1.511,0l1.877,1.364L8.63,8.4A1.281,1.281,0,0,1,9.1,6.961Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralProgram);
export default __webpack_public_path__ + "static/media/referral-program.211a92fb42c2d517582b9ed3c21bb0c2.svg";
export { ForwardRef as ReactComponent };